import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IWorkingHoursService } from "services/WorkingHoursService";
import { OverrideWorkingHoursModel, WorkingHoursModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  StandardWorkingHours: new Array<WorkingHoursModel>(),
  OverrideWorkingHours: new Array<OverrideWorkingHoursModel>(),
  Loading: false,
};

export const workWeekViewSlice = createSlice({
  name: "workWeekViewSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStandardWorkingHours.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getStandardWorkingHours.fulfilled, (state, action) => {
        state.StandardWorkingHours = action.payload;
        state.Loading = false;
      })
      .addCase(getStandardWorkingHours.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getOveriddenWorkingHours.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getOveriddenWorkingHours.fulfilled, (state, action) => {
        state.OverrideWorkingHours = action.payload;
        state.Loading = false;
      })
      .addCase(getOveriddenWorkingHours.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const getStandardWorkingHours = createAsyncThunk("workWeekView/GetStandardWorkingHours", async () => {
  const workingHoursService = container.get<IWorkingHoursService>(SERVICE_TYPES.WorkingHoursService);
  return await workingHoursService.getStandardWorkingHours();
});

export const getOveriddenWorkingHours = createAsyncThunk("workWeekView/GetOveriddenWorkingHours", async () => {
  const workingHoursService = container.get<IWorkingHoursService>(SERVICE_TYPES.WorkingHoursService);
  return await workingHoursService.getOverrideWorkingHours();
});

export const selectStandardWorkingHours = (state: RootState) => {
  return state.workWeekView.StandardWorkingHours;
};
export const selectOveriddenWorkingHours = (state: RootState) => {
  return state.workWeekView.OverrideWorkingHours;
};
export const selectWorkingHoursLoading = (state: RootState) => {
  return state.workWeekView.Loading;
};

export default workWeekViewSlice.reducer;
